import React from 'react';
import { Treemap, ResponsiveContainer, Tooltip } from 'recharts';

import { TvlTreemapTooltip } from './TvlTreemapTooltip';
import { TvlTreemapData } from './types';
import { TvlTreeNodeContent } from './TvlTreeNodeContent';

export function TvlTreemap({ data }: { data: TvlTreemapData[] }) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <Treemap
        data={data}
        dataKey="percent"
        isAnimationActive={false}
        content={renderTreeMapContent()}
      >
        <Tooltip content={renderTooltipContent()} />
      </Treemap>
    </ResponsiveContainer>
  );
}

function renderTreeMapContent() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return <TvlTreeNodeContent />;
}

function renderTooltipContent() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return <TvlTreemapTooltip />;
}
